import { Grid } from '@mui/material';
import { Fragment } from 'react';
import { homeownerPortalLinks, filterNavLinksForAccess } from '../../helpers';
import { ExternalLinkPortalCard, LinkPortalCard, PortalLayout } from '../../components';

export const HomeownerPortal = () => {
  return (
    <PortalLayout title="Homeowner Portals">
      {({ userContext, featureFlags, allowedRoutes }) => {
        return (
          <>
            {filterNavLinksForAccess(
              homeownerPortalLinks,
              userContext,
              featureFlags,
              allowedRoutes
            ).map((link, i) => {
              return (
                <Fragment key={`${i}`}>
                  <Grid xs={12} sm={6} md={4} item>
                    {link.featureFlag && !featureFlags[link.featureFlag] ? (
                      <ExternalLinkPortalCard link={link} />
                    ) : (
                      <LinkPortalCard link={link} />
                    )}
                  </Grid>
                </Fragment>
              );
            })}
          </>
        );
      }}
    </PortalLayout>
  );
};
